"use strict";
/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTestUser = exports.InsecureTokenProvider = void 0;
/**
 * Utilities to use while developing and testing using a service client (for example, AzureClient or TinyliciousClient)
 * supplied by the Fluid Framework.
 *
 * @packageDocumentation
 */
var test_runtime_utils_1 = require("@fluidframework/test-runtime-utils");
Object.defineProperty(exports, "InsecureTokenProvider", { enumerable: true, get: function () { return test_runtime_utils_1.InsecureTokenProvider; } });
var generateTestUser_1 = require("./generateTestUser");
Object.defineProperty(exports, "generateTestUser", { enumerable: true, get: function () { return generateTestUser_1.generateTestUser; } });
//# sourceMappingURL=index.js.map